<template>
  <v-tooltip bottom small>
    <template v-slot:activator="{ on }">
      <v-icon class="ml-1" x-small v-bind="$props" v-on="on" @click.prevent="copyToClipboard">filter_none</v-icon>
    </template>
    <span>Copy to clipboard</span>
  </v-tooltip>
</template>

<script>
export default {
  name: 'CopyToClipboard',
  props: {
    label: {
      type: String,
      default: 'value',
    },
    copyValue: {
      type: [String, Number, Boolean, Object],
      default: undefined,
    },
  },
  data: () => ({
    inputType: 'hidden',
  }),
  methods: {
    copyToClipboard() {
      if (!this.copyValue) return
      navigator.clipboard.writeText(this.copyValue)
      this.$notify({
        text: `${this.label} copied to clipboard`,
      })
    },
  },
}
</script>
